<template>
  <div class="ma-5 ml-3 site_content">

    <div class="as__container">
      <div class="notice__container">
        <div class="flex align-center mt-10">
          <img class="as_icon" :src="require('@/assets/client/as_register.svg')" />
          <span class="as_title">A/S 내역</span>
        </div>
        <div class="as_notice">
          과거 A/S 내역을 한눈에 확인하세요.<br/>
          처리 현황부터 상세한 조치 내용까지 꼼꼼하게 살펴볼 수 있습니다.
        </div>
      </div>
      
      <div class="info__container mb-2" v-if="info.regdate">
          <div class="info_title">접수정보</div>
          <div class="flex">
            <div class="flex mt-3 detail_content">
              <div class="detail_title">사업장명</div>
              <div>{{ info.farm.name }}</div>
            </div>

            <div class="flex mt-3 detail_content">
              <div class="detail_title">A/S 항목</div>
              <div>{{ info.division1.description }}</div>
            </div>
          </div>

          <div class="flex">
            <div class="flex mt-3 detail_content">
              <div class="detail_title">전화번호</div>
              <div>{{ info.phone1 }}</div>
            </div>

            <div class="flex mt-3 detail_content">
              <div class="detail_title">연락가능 시간대</div>
              <div>{{ info.contactable_time }}</div>
            </div>
          </div>

          <div class="flex">
            <div class="flex mt-3 detail_content">
              <div class="detail_title">제목</div>
              <div>{{ info.title }}</div>
            </div>
          </div>

          <div class="detail_title mt-3">접수내용</div>
          <div class="detail_contents">
            {{ info.contents }}
          </div>
          
          <div class="underline"></div>

          <div v-show="info.replies.length > 0">
            <div class="detail_title mt-3">답변</div>

            <div v-for="(re, r) in info.replies" :key="r" >
              <div class="reply-content" :class="r % 2 === 0 ? 'odd-reply' : 'even-reply'">
                {{ re.contents }}
              </div>
            </div>

            <div class="underline"></div>
          </div>

          <div v-show="info.etc3 !== null">
            <div class="detail_title mt-3">처리결과</div>
            <div class="detail_contents">
              <div style="font-weight:550;"> {{ info.etc3 }}에 A/S가 완료 되었습니다. </div>
              <div>{{ info.etc4 }}</div>
            </div>

            <div v-show="invoces.length > 0">
              <div class="mt-3" style="font-weight:550;">💰 유/무상수리 항목</div>
              <v-data-table
                class="invose_table"
                dense
                fixed-header
                :headers="invoces_header"
                :items-per-page="-1" 
                :items="invoces"
                item-key="id"
                single-select
                hide-default-footer
              >
              <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: center;">{{ item.repair_mode }}</td>
                    <td style="text-align: center;">{{ itemText(item.item) }} <span class="ml-2" v-if="item.etc_name !== ''"> ( {{ item.etc_name }} )</span></td>
                    <td style="text-align: center;">{{ item.number }}</td>
                    <td style="text-align: center;">{{ Cost(item.amount) }}</td>
                  </tr>
                </template>
                
                <template v-slot:body.append>
                  <tr class="total-row">
                    <td colspan="3" class="text-center font-weight-bold">합계 (VAT 포함)</td>
                    <td class="text-center font-weight-bold">{{ Cost(total_cost) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
           
          </div>
        </div>

        <div class="history__container">
          <v-data-table
            dense
            height="30vh"
            :items-per-page="-1" 
            fixed-header
            group-by="farm.code"
            :headers="headers"
            :items="items"
            item-key="register_no"
            single-select
            @click:row="infoDetail"
            class="v-table"
          >
            <template v-slot:group.header="{items, isOpen, toggle}">
              <th colspan="6" style="text-align: left !important;">
                <v-icon @click="toggle">
                {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> 
                <span>{{ items[0].farm.name }} </span>
              </th>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="infoDetail(item)" :class="{ 'selected-row': select && select.register_no === item.register_no }">
                <td>{{ item.regdate }}</td>
                <td>{{ item.register_no }}</td>
                
                <td>{{ item.division1.description }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.etc3 }}</td>

                <td>{{ statusText(item.process_status.code) }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
    </div>

  </div>
</template>

<script>
import Apis from '@/api/apis';

export default {
  name: 'AsList',
  data: () => ({
    headers: [
      { text: '접수일자', value: 'regdate' },
      { text: 'A/S 번호', value: 'register_no' },
      { text: 'A/S 항목', value: 'division1.description' },
      { text: '제목', value: 'title' },
      { text: '처리완료일자', value: 'etc3' },
      { text: '처리상황', value: 'process_status.description' },
    ],
    items: [],

    info:{},
    replies: [],
    invoces_header:[
      { text: '유/무상', value: 'repaire_mode',align: 'center', sortable: false },
      { text: '품목명', value: 'item',align: 'center', sortable: false },
      { text: '수량', value: 'number',align: 'center',sortable: false, },
      { text: '비용', value: 'amount',align: 'center',sortable: false,},
    ],

    select: null,
    invoces:[],
    
    total_cost:''

  }),
  created(){
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });
    
    this.history();
    // this.comboFarms();

  },
  methods:{
    statusText(value){
      switch(value) {
        case 1: return '미확인';
        case 2: return '진행중';
        case 3: return '완료'; 
        default: return '알 수 없음';
      }
    },
    history() {
      this.$store.commit("resMessage","");

      Apis.listAsHeads({
        "process_status": 0
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.items = res.data;

        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listAsHeads 호출 오류",err);
      }) 
    },
    itemText(item){
      switch(item) {
        case 'fan': return '팬컨트롤러';
        case 'node': return '센서노드';
        case 'gw': return '멀티게이트';
        case 'fan_temp': return '팬컨트롤러 온도'; 

        case 'dol15': return 'DOL15'; 
        case 'dol115': return 'DOL115'; 
        case 'dol104_10V': return 'DOL104(10V)'; 
        case 'dol104_3V': return 'DOL104(3V)'; 
        case 'dol114': return 'DOL114'; 
        case 'dol119': return 'DOL119'; 
        case 'dol139': return 'DOL139'; 
        case 'dol53': return 'DOL53'; 
        case 'dol53_head': return 'DOL53(헤드)'; 
        case 'dol53_filter': return 'DOL53(먼지필터)'; 
        case 'dol53_cable': return 'DOL53(케이블)'; 
        case 'dol18': return 'DOL18'; 
        case 'dol16': return 'DOL16'; 
        case 'dol15_light': return 'DOL15(조도)'; 

        case 'fix800': return 'FIX800'; 

        case 'sensor': return '센서교정'; 
        case 'power': return '전원불량(SMPS)'; 
        case 'workfare': return '장비위치이동'; 
        case 'out': return '출장비'; 
        case 'shipping': return '택배'; 
        case 'etc': return '기타'; 
 
        default: return '알 수 없음';
      }
    },
    Cost(item){
      return item ? item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';

    },
    infoDetail(item){
      this.select = item;  

      Apis.infoAsProcess({
        "register_no": item.register_no
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.info = res.data;
        this.invoces = res.data.invoices[0].contents;
        
         // amount 총합 계산
        this.total_cost = this.invoces.reduce((sum, entry) => sum + (entry.amount || 0), 0);

        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("infoAsProcess 호출 오류",err);
      }) 
      // console.log(item)
      // console.log(row)
    }
  }
}
</script>

<style scoped  lang="scss">
@import '../info/info_style/info_style.scss';
.as_title{
  font-size:22px;
  color:$main-color;
  font-weight:600;
  letter-spacing: -1.75px;
}
.as_notice{
  font-size:15px;
  letter-spacing: -1px;
  color:#6A6A6A;
}
.as__container{
  width:100%;
  margin-top:10px;
  display:flex;
  flex-direction:column;
  align-items:center;
}
.notice__container{
  width: 80%; 
  align-self: flex-start;
  margin-left: 10%;
  margin-bottom:15px;
}
.info__container, .history__container{
  width:80%;
  background-color:white;
  box-shadow: 2px 3px 4px 0px #bebebe !important;
  letter-spacing: -0.75px;
  border-radius: 30px;
  overflow: hidden;
}
.history__container{
  height:30vh;
}
.info__container{
  background-color: white;
  margin-top:10px;
  padding:20px;
  // border-radius: 30px;
}
.info_title{
  font-weight:600;
  font-size:18px;
}
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
::v-deep .v-data-table-group-header {
  background-color: white !important;
}
::v-deep .selected-row {
  background-color: #E8F3F5 !important;
}
.detail_title{
  width:120px;
  color:#707070;
  font-weight:550;
}
.detail_content{
  width:50%;
}
.detail_contents{
  background-color: #f1f1f1;
  padding:10px;
  border-radius: 10px;
}
.underline{
  width:100%;
  height:1px;
  margin-top:5px;
  margin-bottom: 5px;
  background-color:#d8d8d8 !important;
}
.reply-content{
  padding:10px;
  border-radius: 10px;
  margin:5px 0px;
}
.odd-reply {
  background-color: #f1f1f1 !important;
}
.even-reply {
  background-color: #F5F9FE !important;
}
::v-deep .invose_table .v-data-table-header th{
  background-color: #F0F0F0 !important; 
  color:black !important;
}
::v-deep .invose_table .v-data-table-header th span{
  color:black !important;
  font-weight:500 !important;
}
::v-deep .invose_table .v-data-table-header tr{
  height:20px !important;
  color:black !important;
}
</style>